import React, { useState, useEffect } from "react";
import {
  FnAuthenticatedRequest,
  SERVICES
} from "../../Utility/Utils";
import { MultiSelect } from "react-multi-select-component";
import refresh from "../../assets/images/refresh.svg";
import {
  userTablePageNumber,
  userTablePageSize,
} from "../../Utility/constants";
import StorageHelper from "../../Utility/StorageHelper";
import "react-toastify/dist/ReactToastify.css";
import { APP_ROUTES } from "../../Libraries/AppConstants";
import { useHistory } from "react-router-dom";
import ReactLoadingOverlay from "react-loading-overlay";
import ClipLoader from "react-spinners/ClipLoader";

interface Option {
  label: string;
  value: string;
}

interface GetAllKa {
  fnGetAllFarmers: (params) => void;
  handleResetPageNumber: () => void;
  handleSetMetaParams: (
    projectParams,
    stateParams,
    territoryParams,
    districtParams,
    talukaParams,
    villageParams,
    setSearchInput
  ) => void;
  setSearchInput;
}

const LocationDetails: React.FC<GetAllKa> = ({
  fnGetAllFarmers,
  handleResetPageNumber,
  handleSetMetaParams,
  setSearchInput
}) => {
  const [stateOptions, setStateOptions] = useState<Option[]>([]);
  const [projectOptions, setProjectOptions] = useState<Option[]>([]);
  const [selectedStates, setSelectedStates] = useState<Option[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<Option[]>([]);
  const [districtOptions, setDistrictOptions] = useState<Option[]>([]);
  const [talukaOptions, setTalukaOptions] = useState<Option[]>([]);
  const [villageOptions, setVillageOptions] = useState<Option[]>([]);
  const [selectedDistricts, setSelectedDistricts] = useState<Option[]>([]);
  const [selectedTalukas, setSelectedTalukas] = useState<Option[]>([]);
  const [selectedVillages, setSelectedVillages] = useState<Option[]>([]);
  const [territoryOptions, setTerritoryOptions] = useState<Option[]>([]);
  const [selectedTerritories, setSelectedTerritories] = useState<Option[]>([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [datastloading, setStDataLoading] = useState(false);
  const [datatrloading, setTrDataLoading] = useState(false);
  const [datadiloading, setDiDataLoading] = useState(false);
  const [datataloading, setTaDataLoading] = useState(false);
  const [dataViloading, setViDataLoading] = useState(false);


  const history = useHistory();

  useEffect(() => {
    fetchProjectApi()
  }, []);

  const fetchProjectApi = async () => {
    try {
      setDataLoading(true);
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      if (authData) {
        const authHeader = {
          JWTToken: authData.jwtToken,
          userId: authData.userId,
        };
        const response: any = await FnAuthenticatedRequest(
          "POST",
          "KycOverride/ProjectMaster",
          authHeader,
          "",
          SERVICES.KYC
        );
        if (response?.success) {
          const formattedData = response?.data?.map((project) => ({
            label: project?.projectName?.toUpperCase(),
            value: project?.projectId,
            projectName: project?.projectName?.toUpperCase(),
          }));
          setProjectOptions(formattedData);

          setDataLoading(false);
        }
      }
    } catch (error: any) {
      setDataLoading(false);
      console.error("Error fetching  data:", error);
      if (error?.response && error?.response.status) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          StorageHelper.removeAll();
          document.cookie.split(";").forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(
                /=.*/,
                "=;expires=" + new Date().toUTCString() + ";path=/"
              );
          });

          history.replace(APP_ROUTES.LOGIN);
        } else {
          console.error("Error fetching  data:", error);
        }
      } else {
        console.error("Error fetching  data:", error);
      }
    }
  };



  const fetchStates = async (arrProjectIds: string[]) => {
    try {
      setStDataLoading(true);
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      if (authData) {
        const authHeader = {
          JWTToken: authData.jwtToken,
          userId: authData.userId,
        };
        const response: any = await FnAuthenticatedRequest(
          "POST",
          "KycOverride/StateMaster",
          authHeader,
          {
            "ids": arrProjectIds,
          },
          SERVICES.KYC
        );
        if (response?.success) {
          setStDataLoading(false);
          const filteredData = response?.data?.filter((state) =>
            arrProjectIds.includes(state?.projectId)
          );
          let stateOptions: any = [];
          filteredData?.forEach((state) => {
            let stObject = {
              label: state?.stateName?.toUpperCase(),
              value: state?.stateId,
              stateId: state?.stateId,
              stateName: state?.stateName?.toUpperCase(),
              projectId: state?.projectId,
            }
            stateOptions.push(stObject);
          })

          if (arrProjectIds?.length > 0) {
            setStateOptions(stateOptions);
          }
        } else {
          setStDataLoading(false);
          console.error("Error fetching data :", response?.error);
        }
      }
    } catch (error: any) {
      setStDataLoading(false);
      console.error("Error fetching  data:", error);
      if (error?.response && error?.response.status) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          StorageHelper.removeAll();
          document.cookie.split(";").forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(
                /=.*/,
                "=;expires=" + new Date().toUTCString() + ";path=/"
              );
          });

          history.replace(APP_ROUTES.LOGIN);
        } else {
          console.error("Error fetching  data:", error);
        }
      } else {
        console.error("Error fetching  data:", error);
      }
    }
  };

  useEffect(() => {
    if (selectedProjects?.length > 0) {
      fetchStates(selectedProjects.map((project) => project.value));
    }
    // eslint-disable-next-line
  }, [selectedProjects]);

  useEffect(() => {
    const projectIds = selectedProjects.map((project: any) => project.value);
    const filteredStates = selectedStates.filter((state: any) =>
      projectIds.includes(state.projectId)
    );
    if (selectedProjects?.length === 0) {
      setStateOptions([]);
    }
    setSelectedStates(filteredStates);
    // eslint-disable-next-line
  }, [selectedProjects]);



  useEffect(() => {
    if (selectedStates?.length > 0) {
      fetchStateWiseTeritaory(selectedStates.map((state) => state.value));
    }
    // eslint-disable-next-line
  }, [selectedStates]);

  useEffect(() => {
    if (selectedTerritories?.length > 0) {
      fetchDistricts(selectedTerritories.map((territory) => territory.value));
    }
    // eslint-disable-next-line
  }, [selectedTerritories]);

  useEffect(() => {
    if (selectedDistricts?.length > 0) {
      fetchTalukas(selectedDistricts.map((district) => district.value));
    }
    // eslint-disable-next-line
  }, [selectedDistricts]);

  useEffect(() => {
    if (selectedTalukas?.length > 0) {
      fetchVillages(selectedTalukas.map((taluka) => taluka.value));
    }
    // eslint-disable-next-line
  }, [selectedTalukas]);

  useEffect(() => {
    const stateIds = selectedStates.map((state: any) => state.value);
    const filteredTerritories = selectedTerritories.filter((territory: any) =>
      stateIds.includes(territory.stateId)
    );
    if (selectedStates?.length === 0) {
      setTerritoryOptions([]);
    }
    setSelectedTerritories(filteredTerritories);
    // eslint-disable-next-line
  }, [selectedStates]);

  useEffect(() => {
    const territoryIds = selectedTerritories.map(
      (territory: any) => territory.value
    );
    const filteredDistricts = selectedDistricts.filter((district: any) =>
      territoryIds.includes(district.territoryId)
    );
    if (selectedTerritories?.length === 0) {
      setDistrictOptions([]);
    }
    setSelectedDistricts(filteredDistricts);
    // eslint-disable-next-line
  }, [selectedTerritories]);


  useEffect(() => {
    const districtIds = selectedDistricts.map(
      (district: any) => district.value
    );
    const filteredTalukas = selectedTalukas.filter((taluka: any) =>
      districtIds.includes(taluka.districtId)
    );
    if (selectedDistricts?.length === 0) {
      setTalukaOptions([]);
    }
    setSelectedTalukas(filteredTalukas);
    // eslint-disable-next-line
  }, [selectedDistricts]);

  useEffect(() => {
    const talukaIds = selectedTalukas.map(
      (taluka: any) => taluka.value
    );
    const filteredVillages = selectedVillages.filter((village: any) =>
      talukaIds.includes(village.talukaId)
    );
    if (selectedTalukas?.length === 0) {
      setVillageOptions([]);
    }
    setSelectedVillages(filteredVillages);
    // eslint-disable-next-line
  }, [selectedTalukas]);



  const fetchStateWiseTeritaory = async (arrStateIds: string[]) => {
    try {
      setTrDataLoading(true);
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      if (authData) {
        const authHeader = {
          JWTToken: authData.jwtToken,
          userId: authData.userId,
        };
        const response: any = await FnAuthenticatedRequest(
          "POST",
          "KycOverride/territoryMaster",
          authHeader,
          { "ids": arrStateIds },
          SERVICES.KYC
        );
        if (response?.success) {
          setTrDataLoading(false);
          const filteredData = response?.data?.filter((tr) =>
            arrStateIds.includes(tr.stateId)
          );
          let territoryOptions: any = [];
          filteredData?.forEach((tr) => {
            let trObject = {
              label: tr.territoryName?.toUpperCase(),
              value: tr.territoryId,
              trId: tr.territoryId,
              territoryName: tr.territoryName?.toUpperCase(),
              stateId: tr.stateId,
            };
            territoryOptions.push(trObject);
          });
          if (arrStateIds?.length > 0) {
            setTerritoryOptions(territoryOptions);
          }
        } else {
          setTrDataLoading(false);
          console.error("Error fetching data :", response?.error);
        }
      }
    } catch (error: any) {
      setTrDataLoading(false);
      console.error("Error fetching  states:", error);
      if (error.response && error.response.status) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          StorageHelper.removeAll();
          document.cookie.split(";").forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(
                /=.*/,
                "=;expires=" + new Date().toUTCString() + ";path=/"
              );
          });

          history.replace(APP_ROUTES.LOGIN);
        } else {
          console.error("Error fetching  states:", error);
        }
      } else {
        console.error("Error fetching  states:", error);
      }
    }
  };
  const fetchDistricts = async (arrTrIds: string[]) => {
    try {
      setDiDataLoading(true);
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      const authHeader = {
        JWTToken: authData.jwtToken,
        userId: authData.userId,
      };

      const response: any = await FnAuthenticatedRequest(
        "POST",
        "KycOverride/DistrictMaster",
        authHeader,
        { "ids": arrTrIds },
        SERVICES.KYC
      );
      if (response?.success) {
        setDiDataLoading(false);
        const data: any = response?.data;
        let districtOptions = data?.map((district) => {
          let districtObject = {
            label: district.districtName?.toUpperCase(),
            value: district.districtId,
            districtId: district.districtId,
            districtName: district.districtName?.toUpperCase(),
            stateId: district.stateId,
            territoryId: district.territoryId,
          };
          return districtObject;
        });
        if (arrTrIds?.length > 0) {
          setDistrictOptions(districtOptions);
        }
      } else {
        console.error("Error fetching districts:", response?.error);
      }
    } catch (error: any) {
      setDiDataLoading(false);
      console.error("Error fetching  districts:", error);
      if (error.response && error.response.status) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          StorageHelper.removeAll();
          document.cookie.split(";").forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(
                /=.*/,
                "=;expires=" + new Date().toUTCString() + ";path=/"
              );
          });

          history.replace(APP_ROUTES.LOGIN);
        } else {
          console.error("Error fetching  districts:", error);
        }
      } else {
        console.error("Error fetching  districts:", error);
      }
    }
  };
  const fetchTalukas = async (arrDiIds: string[]) => {
    try {
      setTaDataLoading(true);
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      const authHeader = {
        JWTToken: authData.jwtToken,
        userId: authData.userId,
      };

      const response: any = await FnAuthenticatedRequest(
        "POST",
        "KycOverride/TalukaMaster",
        authHeader,
        { "ids": arrDiIds },
        SERVICES.KYC
      );

      if (response?.success) {
        setTaDataLoading(false);
        const data: any = response?.data;
        let talukaOptions = data?.map((taluka) => {
          let districtObject = {
            label: taluka.talukaName?.toUpperCase(),
            value: taluka.talukaId,
            talukaId: taluka.talukaId,
            talukaName: taluka.talukaName?.toUpperCase(),
            districtId: taluka.districtId,
          };
          return districtObject;
        });
        if (arrDiIds?.length > 0) {
          setTalukaOptions(talukaOptions);
        }
      } else {
        console.error("Error fetching taluka:", response?.error);
      }
    } catch (error: any) {
      setTaDataLoading(false);
      console.error("Error fetching  taluka:", error);
      if (error.response && error.response.status) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          StorageHelper.removeAll();
          document.cookie.split(";").forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(
                /=.*/,
                "=;expires=" + new Date().toUTCString() + ";path=/"
              );
          });

          history.replace(APP_ROUTES.LOGIN);
        } else {
          console.error("Error fetching  taluka:", error);
        }
      } else {
        console.error("Error fetching  taluka:", error);
      }
    }
  };

  const fetchVillages = async (arrTaIds: string[]) => {
    try {
      setViDataLoading(true);
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      const authHeader = {
        JWTToken: authData.jwtToken,
        userId: authData.userId,
      };

      const response: any = await FnAuthenticatedRequest(
        "POST",
        "KycOverride/VillageMaster",
        authHeader,
        { "ids": arrTaIds },
        SERVICES.KYC
      );
      if (response?.success) {
        setViDataLoading(false);
        const data: any = response?.data;
        let villageOptions = data?.map((village) => {
          let villageObject = {
            label: village.villageName?.toUpperCase(),
            value: village.villageId,
            villageId: village.villageId,
            villageName: village.villageName?.toUpperCase(),
            talukaId: village.talukaId,
          };
          return villageObject;
        });
        if (arrTaIds?.length > 0) {
          setVillageOptions(villageOptions);
        }
      } else {
        console.error("Error fetching village:", response?.error);
      }
    } catch (error: any) {
      setTaDataLoading(false);
      console.error("Error fetching  village:", error);
      if (error.response && error.response.status) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          StorageHelper.removeAll();
          document.cookie.split(";").forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(
                /=.*/,
                "=;expires=" + new Date().toUTCString() + ";path=/"
              );
          });

          history.replace(APP_ROUTES.LOGIN);
        } else {
          console.error("Error fetching  village:", error);
        }
      } else {
        console.error("Error fetching  village:", error);
      }
    }
  };

  const clearSelections = () => {
    const input = setSearchInput?.length > 3 ? setSearchInput : null;
    setSelectedStates([]);
    setSelectedProjects([]);
    setSelectedDistricts([]);
    setSelectedTalukas([]);
    setSelectedVillages([]);
    setSelectedTerritories([]);
    setTerritoryOptions([]);
    setDistrictOptions([]);
    setTalukaOptions([]);
    setVillageOptions([]);
    handleResetPageNumber();
    handleSetMetaParams(null, null, null, null, null, null, input);

    const params = {
      pageNo: userTablePageNumber,
      pageSize: userTablePageSize,
      states: null,
      territories: null,
      districts: null,
      project: null,
      talukas: null,
      village: null,
      searchInput: input,
    };
    fnGetAllFarmers(params);
  };

  const customMessages = {
    allItemsAreSelected: "All",
    selectSomeItems: "All",
    selectAllFiltered: "All",
  };

  useEffect(() => {
    if (selectedDistricts?.length && districtOptions?.length) {
      const filteredSelectedDistricts = selectedDistricts.filter((district) =>
        districtOptions.some((option) => option.value === district.value)
      );
      setSelectedDistricts(filteredSelectedDistricts);
    }
    // eslint-disable-next-line
  }, [districtOptions]);

  useEffect(() => {
    if (selectedTalukas?.length && talukaOptions?.length) {
      const filteredSelectedTalukas = selectedTalukas.filter((taluka) =>
        talukaOptions.some((option) => option.value === taluka.value)
      );
      setSelectedTalukas(filteredSelectedTalukas);
    }
    // eslint-disable-next-line
  }, [talukaOptions]);

  useEffect(() => {
    if (selectedVillages?.length && villageOptions?.length) {
      const filteredSelectedVillages = selectedVillages.filter((village) =>
        villageOptions.some((option) => option.value === village.value)
      );
      setSelectedVillages(filteredSelectedVillages);
    }
    // eslint-disable-next-line
  }, [villageOptions]);

  const customDisplayValueProjects = () => {
    if (
      selectedProjects?.length === 0 ||
      selectedProjects?.length === projectOptions?.length
    ) {
      return "All";
    } else {
      return `${selectedProjects?.length} selected`;
    }
  };

  const customDisplayValueStates = () => {
    if (
      selectedStates?.length === 0 ||
      selectedStates?.length === stateOptions?.length
    ) {
      return "All";
    } else {
      return `${selectedStates?.length} selected`;
    }
  };
  const customDisplayValueDistrict = () => {
    if (
      selectedDistricts?.length === 0 ||
      selectedDistricts?.length === districtOptions?.length
    ) {
      return "All";
    } else {
      return `${selectedDistricts?.length} selected`;
    }
  };
  const customDisplayValueTerritory = () => {
    if (
      selectedTerritories?.length === 0 ||
      selectedTerritories?.length === territoryOptions?.length
    ) {
      return "All";
    } else {
      return `${selectedTerritories?.length} selected`;
    }
  };

  const customDisplayValueTaluka = () => {
    if (
      selectedTalukas?.length === 0 ||
      selectedTalukas?.length === talukaOptions?.length
    ) {
      return "All";
    } else {
      return `${selectedTalukas?.length} selected`;
    }
  };

  const customDisplayValueVillage = () => {
    if (
      selectedVillages?.length === 0 ||
      selectedVillages?.length === villageOptions?.length
    ) {
      return "All";
    } else {
      return `${selectedVillages?.length} selected`;
    }
  };

  const handleApply = () => {
    try {
      handleResetPageNumber();
      const arrProjects = selectedProjects.map((project: any) => project?.value);
      const arrStates = selectedStates.map((state: any) => state?.value);
      const arrTerritories = selectedTerritories.map(
        (territory: any) => territory?.value
      );
      const arrDisctricts = selectedDistricts.map(
        (district: any) => district?.value
      );
      const arrTalukas = selectedTalukas.map(
        (taluka: any) => taluka?.value
      );
      const arrVillages = selectedVillages.map(
        (village: any) => village?.value
      );
      const projectParams = arrProjects?.length > 0 ? arrProjects : null;
      const stateParams = arrStates?.length > 0 ? arrStates : null;
      const territoryParams =
        arrTerritories?.length > 0 ? arrTerritories : null;
      const districtParams = arrDisctricts?.length > 0 ? arrDisctricts : null;
      const talukaParams = arrTalukas?.length > 0 ? arrTalukas : null;
      const villageParams = arrVillages?.length > 0 ? arrVillages : null;

      const input = setSearchInput?.length >= 4 ? setSearchInput : "";


      const params = {
        pageNo: 0,
        pageSize: userTablePageSize,
        project: projectParams,
        states: stateParams,
        territories: territoryParams,
        districts: districtParams,
        talukas: talukaParams,
        village: villageParams,
        searchInput: input,
      };
      handleSetMetaParams(
        projectParams,
        stateParams,
        territoryParams,
        districtParams,
        talukaParams,
        villageParams,
        input
      );
      fnGetAllFarmers(params);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="card min-w-full">
      <div className="card-body min-w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-3 md:grid-cols-7 md:gap-5 min-w-full">

          {/* Project */}
          <div>
            <label id="state">Project</label>
            <MultiSelect
              options={projectOptions}
              value={selectedProjects}
              onChange={setSelectedProjects}
              hasSelectAll={false}
              labelledBy="Project"
              valueRenderer={customDisplayValueProjects}
              overrideStrings={customMessages}
              shouldToggleOnHover={false}
            />
          </div>

          {/* State */}
          <div>
            <label id="state">State</label>
            {
              !datastloading ? (
                <MultiSelect
                  options={stateOptions}
                  value={selectedStates}
                  onChange={setSelectedStates}
                  hasSelectAll={false}
                  labelledBy="state"
                  valueRenderer={customDisplayValueStates}
                  overrideStrings={customMessages}
                  shouldToggleOnHover={false}
                />
              ) : (
                <div style={{ position: "relative" }}>
                  <MultiSelect
                    options={stateOptions}
                    value={selectedStates}
                    onChange={setSelectedStates}
                    labelledBy="state"
                    hasSelectAll={false}
                    overrideStrings={customMessages}
                    shouldToggleOnHover={false}
                    valueRenderer={customDisplayValueTerritory}
                    disabled={true}
                    disableSearch={true}
                  />
                  {/* Loading spinner */}
                  <ReactLoadingOverlay
                    classNamePrefix="growindigo_"
                    active={true}
                    spinner={<ClipLoader color="#27878E" />}
                    text={""}
                  >
                    {/* Your content here */}
                  </ReactLoadingOverlay>
                </div>

              )
            }

          </div>

          {/* Territory */}
          <div>
            <label id="territory-add-user">Territory</label>
            {!datatrloading ? (
              <MultiSelect
                options={territoryOptions}
                value={selectedTerritories}
                onChange={setSelectedTerritories}
                labelledBy="territory-add-user"
                hasSelectAll={false}
                valueRenderer={customDisplayValueTerritory}
                overrideStrings={customMessages}
                shouldToggleOnHover={false}
              />
            ) : (
              <div style={{ position: "relative" }}>
                <MultiSelect
                  options={territoryOptions}
                  value={selectedTerritories}
                  onChange={setSelectedTerritories}
                  labelledBy="territory-add-user"
                  hasSelectAll={false}
                  overrideStrings={customMessages}
                  shouldToggleOnHover={false}
                  valueRenderer={customDisplayValueTerritory}
                  disabled={true}
                  disableSearch={true}
                />
                {/* Loading spinner */}
                <ReactLoadingOverlay
                  classNamePrefix="growindigo_"
                  active={true}
                  spinner={<ClipLoader color="#27878E" />}
                  text={""}
                >
                  {/* Your content here */}
                </ReactLoadingOverlay>
              </div>
            )}
          </div>

          {/* District */}
          <div>
            <label id="disctrict">District</label>
            {!datadiloading ? (
              <MultiSelect
                options={districtOptions}
                value={selectedDistricts}
                onChange={setSelectedDistricts}
                labelledBy="disctrict"
                hasSelectAll={false}
                valueRenderer={customDisplayValueDistrict}
                overrideStrings={customMessages}
              />
            ) : (
              <div style={{ position: "relative" }}>
                <MultiSelect
                  options={districtOptions}
                  value={selectedDistricts}
                  onChange={setSelectedDistricts}
                  labelledBy="disctrict"
                  hasSelectAll={false}
                  valueRenderer={customDisplayValueDistrict}
                  overrideStrings={customMessages}
                  disabled={true}
                  disableSearch={true}
                />
                {/* Loading spinner */}
                <ReactLoadingOverlay
                  classNamePrefix="growindigo_"
                  active={true}
                  spinner={<ClipLoader color="#27878E" />}
                  text={""}
                >
                  {/* Your content here */}
                </ReactLoadingOverlay>
              </div>
            )}
          </div>

          {/* {Block} taluka*/}
          <div>
            <label id="taluka">Block</label>
            {!datataloading ? (
              <MultiSelect
                options={talukaOptions}
                value={selectedTalukas}
                onChange={setSelectedTalukas}
                labelledBy="taluka"
                hasSelectAll={false}
                valueRenderer={customDisplayValueTaluka}
                overrideStrings={customMessages}
              />
            ) : (
              <div style={{ position: "relative" }}>
                <MultiSelect
                  options={talukaOptions}
                  value={selectedTalukas}
                  onChange={setSelectedTalukas}
                  labelledBy="taluka"
                  hasSelectAll={false}
                  valueRenderer={customDisplayValueTaluka}
                  overrideStrings={customMessages}
                  disabled={true}
                  disableSearch={true}
                />
                {/* Loading spinner */}
                <ReactLoadingOverlay
                  classNamePrefix="growindigo_"
                  active={true}
                  spinner={<ClipLoader color="#27878E" />}
                  text={""}
                >
                  {/* Your content here */}
                </ReactLoadingOverlay>
              </div>
            )}
          </div>

          {/*  Village*/}
          <div>
            <label id="village">Village</label>
            {!dataViloading ? (
              <MultiSelect
                options={villageOptions}
                value={selectedVillages}
                onChange={setSelectedVillages}
                labelledBy="village"
                hasSelectAll={false}
                valueRenderer={customDisplayValueVillage}
                overrideStrings={customMessages}
              />
            ) : (
              <div style={{ position: "relative" }}>
                <MultiSelect
                  options={villageOptions}
                  value={selectedVillages}
                  onChange={setSelectedVillages}
                  labelledBy="village"
                  hasSelectAll={false}
                  valueRenderer={customDisplayValueVillage}
                  overrideStrings={customMessages}
                  disabled={true}
                  disableSearch={true}
                />
                {/* Loading spinner */}
                <ReactLoadingOverlay
                  classNamePrefix="growindigo_"
                  active={true}
                  spinner={<ClipLoader color="#27878E" />}
                  text={""}
                >
                  {/* Your content here */}
                </ReactLoadingOverlay>
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-4 items-center mt-4 min-w-full">
            <button
              className="bg-white text-[#406BBE] font-semibold border border-[#406BBE] px-5 py-1.5 rounded transition-all hover:bg-[#406BBE] hover:text-white active:bg-[#34508B] active:border-[#34508B]"
              onClick={() => {
                handleApply();
              }}
            >
              Apply
            </button>
            <button onClick={clearSelections}>
              <img src={refresh} alt="home_icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;
